<template>
  <div>
      <Rooms></Rooms>
  </div>
</template>
<script>
import { useStore } from "Vuex";
import { computed, ref } from "Vue";
import Rooms from "./ListRooms.vue";
export default {
  components: {
    Rooms,
  },
  props: {
    title: String,
    price: Number,
  },
  setup() {},
};
</script>